import AskWavesIcon from '../../../ui/svg/common/ask-waves-icon';
import { useEffect, useState } from 'react';
import { getABTest, sendABTestAnalytics } from '../../../domain/abtest/abtest-provider';
import { sendGAEvent } from '../../../domain/marketing/gtm-provider';

/**
 * https://wavesaudio.atlassian.net/browse/DSWEB-5501
 */
interface ITopMenuAskWavesBtnProps {
    classes: string;
}

const TopMenuAskWavesBtn = ({ classes }: ITopMenuAskWavesBtnProps) => {

    const [showAskWaves, setShowAskWaves] = useState(false);

    useEffect(() => {
        const abtest = getABTest('AskWaves');
        if(!abtest?.isActive) return;
        sendABTestAnalytics(abtest);
        setShowAskWaves(abtest.selected === 'yes');
    }, []);

    return (
        <>
            {
                showAskWaves &&
                <button
                    type="button"
                    data-ask-waves={ true }
                    onClick={ () => {
                        sendGAEvent('Click', 'Ask Waves Top Menu');
                    }}
                    className={ `${ classes ?? '' } top-menu-ask-waves-btn flex items-center gap-1 bg-blue-200 pl-2 pr-4 py-1 rounded-3xl` }>
                        <span className="flex items-center justify-center rounded-full" style={{
                            width: '22px',
                            height: '22px',
                        }}><AskWavesIcon /></span>
                        <span className="ask-waves-btn-text ">Ask Waves</span>
                </button>
            }
        </>
    )
};

export default TopMenuAskWavesBtn;